import { AxiosInstance } from "../../../axios/axiosInstance";
import { apiRoutes } from "../../../utils/ApiRoutes";

export const resellingConnectAccountApi = async () => {
  const response = await AxiosInstance.post(apiRoutes.resellingConnectAccount);
  return response;
};

export const resellingAccountStatusApi = async () => {
  const response = await AxiosInstance.get(apiRoutes.resellingAccountStatus);
  return response;
};

export const resellingDisconnectApi = async () => {
  const response = await AxiosInstance.post(apiRoutes.resellingDisconnect);
  return response;
};

export const resellingConfigApi = async () => {
  const response = await AxiosInstance.get(apiRoutes.resellingConfig);
  return response;
};

export const updateCheckinConfigApi = async (data: {
  checkin_enabled: boolean;
  resale_price_cents: number;
  trial_days: number;
  require_payment_upfront: boolean;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes.resellingUpdateCheckinConfig,
    data,
  );
  return response;
};

export const updateCreditConfigApi = async (data: {
  credits_enabled: boolean;
  markup_multiplier: number;
  credits_per_action: number;
}) => {
  const response = await AxiosInstance.post(
    apiRoutes.resellingUpdateCreditConfig,
    data,
  );
  return response;
};

export const resellingClientsPaginatedApi = async (data?: {
  page?: number;
  limit?: number;
  search?: string;
  sort_by?: string;
  sort_order?: string;
  status?: string;
  date_from?: string;
  date_to?: string;
}) => {
  const payload = {
    page: data?.page ?? 1,
    limit: data?.limit ?? 10,
    ...data,
  };
  const response = await AxiosInstance.post(
    apiRoutes.resellingClientsPaginated,
    payload,
  );
  return response;
};

export const resellingOverviewStatsApi = async (payload?: any) => {
  const response = await AxiosInstance.post(
    apiRoutes.resellingOverviewStats,
    payload || {},
  );
  return response;
};

export const resellingDashboardLinkApi = async () => {
  const response = await AxiosInstance.get(apiRoutes.resellingDashboardLink);
  return response;
};


